"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/// <reference types="jquery"/>
var vue_1 = __importDefault(require("vue"));
var vue_select_1 = __importDefault(require("vue-select"));
var ConditionalDisplay_1 = __importDefault(require("../../Mixins/ConditionalDisplay"));
var PredicateInput_1 = __importDefault(require("../../Mixins/PredicateInput"));
var SourceValue_1 = __importDefault(require("../../Mixins/SourceValue"));
exports.default = vue_1.default.extend({
    props: ['name', 'label', 'type', 'required', 'placeholder', 'multiple', 'options', 'parametersTemplate', 'parameters', 'handlerControls'],
    components: { vSelect: vue_select_1.default },
    mixins: [ConditionalDisplay_1.default, PredicateInput_1.default, SourceValue_1.default],
    data: function () {
        var model = this.$root.$data;
        return {
            items: this.options || [],
            readonly: model.readOnly
        };
    },
    methods: {
        getData: function () {
            var _this = this;
            var model = this.$root.$data, self = this, data = {
                idAffaire: model.affaireId,
                idBc: model.bonCommandeId,
                type: this.type
            };
            setTimeout(function () {
                if (_this.parameters) {
                    var params = _this.parameters.split(","), template = _this.parametersTemplate ? _this.parametersTemplate.split(",") : null, oParams = {};
                    $.each(params, function (i, p) {
                        var templateName = template ? template[i] : p;
                        if (p.indexOf("|") !== -1) {
                            var pWithCond = p.split("|"), $p = $("[name='" + pWithCond[1] + "']"), $cond = $("[name='" + pWithCond[0] + "']"), isCbOrRad = $cond.is(":radio") || $cond.is(":checkbox");
                            if ((isCbOrRad && $cond.is(":checked"))
                                || (!isCbOrRad && $cond.val() && $cond.val() !== "[]")) {
                                var val = $p.val() || $p.text();
                                if (val) {
                                    templateName = template ? templateName : pWithCond[1];
                                    oParams[templateName] = val;
                                }
                            }
                        }
                        else {
                            var val = $("[name='" + p + "']").val() || $("[name='" + p + "']").text();
                            if (val) {
                                oParams[templateName] = val;
                            }
                        }
                    });
                    if (oParams != {}) {
                        data["otherParam"] = JSON.stringify(oParams);
                    }
                }
                $.ajax({
                    url: '/Affaires/LoadDataForSelectComponent',
                    type: 'get',
                    data: data,
                }).done(function (data) {
                    self.items = $.map(data, function (_) {
                        if (_.text === null || _.text === undefined) {
                            _.text = _.value;
                        }
                        return _;
                    });
                    self.getFiltered();
                }).fail(function () {
                });
            }, 300);
        },
        getOptions: function () {
            if (!this.items || this.items.length === 0) {
                return this.getData();
            }
            return this.getFiltered();
        },
        getFiltered: function () {
            var _this = this;
            if (!this.items) {
                return;
            }
            return this.items.filter(function (i) { return _this.value === null || (_this.value.indexOf && _this.value.indexOf(i.value) === -1); });
        },
        onChange: function (item) {
            if (!this.items || this.items.length === 0) {
                return;
            }
            if (this.multiple !== undefined && this.multiple !== 'false') {
                var selection = [];
                $.each(item, function (i, s) {
                    selection.push(s.value || s);
                });
                this.selected = selection.join(',');
            }
            else {
                this.selected = item == null ? '' : item.value;
            }
            this.$emit("input", this.selected);
        },
        getPredicateValue: function () {
            return this.selected;
        },
    },
    mounted: function () {
        this.getOptions();
        if (this.handlerControls) {
            var self = this;
            $(document).on("change", $.map(self.handlerControls.split(","), function (c) { return "[name='" + c + "']"; }).join(","), function () {
                self.items = [];
                self.getOptions();
            });
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/Workflow/Components/Input/SelectCustom.vue
// module id = 189
// module chunks = 0